import { DEFAULT_SUPPLIER_TYPE_VENDOR_CLASS_IDS } from 'utils/constants'

export const isDefaultRow = params => {
  if (!params) return false
  return DEFAULT_SUPPLIER_TYPE_VENDOR_CLASS_IDS.indexOf(params?.row?.id) > -1
}
